import styled, { css } from 'styled-components';

import { Button } from '../Button';
import { Flex } from '../Flex';
import { Typography } from '../Typography';

import { ReactComponent as Ticket } from '@/assets/icons/ticket.svg';
import { ReactComponent as TicketHalf } from '@/assets/icons/ticket-half.svg';

export const Voucher = styled(Flex)`
  align-items: center;

  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
    padding: ${theme.spacing(2)};

    ${theme.media.md.up} {
      border-bottom: none;
      position: relative;
      margin-bottom: ${theme.spacing(1)};
      padding: ${theme.spacing(4)};
    }
  `}
`;

export const VoucherIconMobile = styled(Ticket)`
  height: 46px;

  ${({ theme }) => css`
    margin-right: ${theme.spacing(1)};

    ${theme.media.md.up} {
      display: none;
    }
  `}
`;

export const VoucherIconDesktop = styled(TicketHalf)`
  display: none;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      display: block;
      position: absolute;
      height: 36px;
      left: 0;
      top: 28px;
    }
  `}
`;

export const VoucherWrapper = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: 10px;
  .voucher-accordion {
    margin-top: 0;
    & > header {
      border-bottom: 0;
      button {
        padding: 16px 0;
        background-color: white;
      }
    }
  }
`;

export const VoucherHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const VoucherTitle = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.secondary};
  `}
`;

export const VoucherChange = styled.button`
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: ${({ theme }) => theme.fontSizes.p3};
  color: ${({ theme }) => theme.colors.navyBlueSub1};
  font-family: inherit;
`;

export const VoucherCodeWrapper = styled(Flex)`
  flex-direction: column;
  gap: 10px;
`;

export const VoucherCode = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
  `}
`;

export const VoucherInfo = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const VoucherButton = styled(Button)`
  padding: 0 24px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryDark};
  border-color: ${({ theme }) => theme.colors.primaryDark};
  font-size: ${({ theme }) => theme.fontSizes.p3};
`;

export const VoucherInput = styled.input`
  border: none;
  outline: none;
  height: 40px;
  width: 100%;

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    border-bottom: 1px solid ${theme.colors.inputGrey};
    padding: ${theme.spacing(1)};
    font-size: ${theme.fontSizes.p2};
  `}
`;

export const VoucherInputWrapper = styled(Flex)`
  gap: 10px;
`;
